import { createSelector } from 'reselect';
import { showPDPTopOfPageRedesignSelector } from 'selectors/testTarget/offers/showPDPTopOfPageRedesign/showPDPTopOfPageRedesignSelector';

const showSelector = createSelector(showPDPTopOfPageRedesignSelector, showPDPTopOfPageRedesign => !!showPDPTopOfPageRedesign.show);

export { showSelector };
